// US-style ringback tone — 440 Hz + 480 Hz dual sine, 2s on / 4s off.
// Played to the rep while the outbound leg is ringing so they hear
// something instead of dead silence. Uses Web Audio API — zero
// dependencies, works in every modern browser.
//
// The mixer output stays disconnected until start() so we don't
// accidentally leak audio if the module is imported but never used.

let ctx = null;
let osc1 = null;
let osc2 = null;
let gain = null;
let cadenceTimer = null;

function ensureCtx() {
  if (ctx) return ctx;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  ctx = new AC();
  return ctx;
}

export function start() {
  const c = ensureCtx();
  if (!c) return;
  // If the browser suspended the context (autoplay policy), resume.
  if (c.state === "suspended") c.resume().catch(() => {});
  if (osc1) return; // already ringing
  gain = c.createGain();
  gain.gain.value = 0;
  gain.connect(c.destination);
  osc1 = c.createOscillator();
  osc1.type = "sine";
  osc1.frequency.value = 440;
  osc1.connect(gain);
  osc2 = c.createOscillator();
  osc2.type = "sine";
  osc2.frequency.value = 480;
  osc2.connect(gain);
  osc1.start();
  osc2.start();
  // Cadence: 2s tone / 4s silence, repeating.
  const beep = () => {
    const now = c.currentTime;
    // Ramp up to a comfortable level (~ -18 dBFS), hold 2s, ramp down.
    gain.gain.cancelScheduledValues(now);
    gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(0.12, now + 0.05);
    gain.gain.setValueAtTime(0.12, now + 2.0);
    gain.gain.linearRampToValueAtTime(0, now + 2.1);
  };
  beep();
  cadenceTimer = setInterval(beep, 6000);
}

export function stop() {
  if (cadenceTimer) { clearInterval(cadenceTimer); cadenceTimer = null; }
  try { osc1?.stop(); } catch { /* ignore */ }
  try { osc2?.stop(); } catch { /* ignore */ }
  try { osc1?.disconnect(); osc2?.disconnect(); gain?.disconnect(); } catch { /* ignore */ }
  osc1 = null; osc2 = null; gain = null;
}
